import React from 'react'
import { useTranslation } from 'react-i18next'

import type { DashboardLabTestEntry } from '~/api/graphql/generated/types'
import BusinessShareIcon from '~/components/common/icons/BusinessShareIcon'

import { useRightRailOverlay } from '../../context/RightRailOverlayContext'
import LabTestDetailsOverlay from './LabTestDetailsOverlay'

import styles from './LabNameCell.module.scss'

interface LabNameCellProps {
  item: DashboardLabTestEntry
}

const LabNameCell = ({ item }: LabNameCellProps) => {
  const { openOverlay } = useRightRailOverlay()
  const { t } = useTranslation('LabTests')

  const handleLabNameClick = () => {
    const overlayContent = <LabTestDetailsOverlay labTest={item} />
    openOverlay(overlayContent)
  }

  // Get business IDs - prefer testLogs businessId, fallback to appointment businessId
  const businessIds = Array.from(
    new Set(
      [
        ...(item.testLogs?.map((log) => log.businessId) ?? []),
        item.appointment?.businessId,
      ].filter((id): id is string => Boolean(id)),
    ),
  )

  return (
    <div className={styles.labNameContainer}>
      <div className={styles.namesWrapper}>
        {item.testLogs?.map((entry) => (
          <button
            aria-label={t('OPEN_LAB_DETAILS', { labName: entry.name })}
            className={styles.labNameButton}
            key={entry.id}
            title={t('OPEN_LAB_DETAILS', { labName: entry.name })}
            type="button"
            onClick={handleLabNameClick}
          >
            {entry.name}
          </button>
        ))}
      </div>
      <BusinessShareIcon businessIds={businessIds} color="black" />
    </div>
  )
}

export default LabNameCell
